import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { ToastProvider } from './components/ToastProvider';
import { sweepStaleMuxTempFiles } from './lib/videoExport';
import './styles/fonts.css';
import './styles/tokens.css';
import './styles/global.css';

// Build stamp — written to window so the constant survives Vite's
// dead-code elimination and the bundle's content hash bumps on every
// commit. Lets us force-reupload assets after CF Pages serves a corrupt
// /assets/main-<hash>.js (where redeploying identical content can't help
// because the hash matches).
(window as unknown as { __VOICE_STUDIO_BUILD__: string }).__VOICE_STUDIO_BUILD__ =
  '2026-05-08T20:05:00Z';

// Reclaim OPFS quota from any leftover upload-mux temp files. Fire-and-
// forget — failure is non-fatal; if quota does fill up the next mux run
// surfaces the error via createSyncAccessHandle.
void sweepStaleMuxTempFiles();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <ToastProvider>
        <App />
      </ToastProvider>
    </BrowserRouter>
  </StrictMode>
);
